<template>
  <v-main class="pa-2" fluid>

    <v-form @submit.prevent="changeRange" v-model="valid">

      <v-row>
        <v-col cols="12" class="inline-form">

          <v-text-field v-model="name" append-icon="mdi-magnify" label="Customer, Merch or Addons"></v-text-field>

          <SearchRangePicker @reloadData="changeRange" />

        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="12" class="inline-form filters">
          <v-select v-model="filters.selectedCodes" :items="codes" :menu-props="{ maxHeight: '400' }" label="Package"
            multiple persistent-hint></v-select>
          <v-select v-model="filters.status" :items="statusOpts" :menu-props="{ maxHeight: '400' }" item-text="text"
            item-value="id" label="Status" multiple persistent-hint></v-select>
          <v-select v-model="filters.transport" :items="transportOpts" label="Transport" multiple>
          </v-select>
          <v-select v-model="filters.paymentMethod" :items="paymentMethodOpts" label="Payment" multiple>
          </v-select>
          <v-select v-model="filters.agent" :items="agentsNames" label="Agent" multiple>
          </v-select>
        </v-col>
      </v-row>


    </v-form>


    <v-data-table :headers="headers" :items="filteredResults" :items-per-page="30" item-key="id" :search="name"
      sort-by="startTime">
      <template v-slot:item.actions="{ item }">

        <v-btn icon v-if="item.incomplete || item.future" small class="success white--text ma-2"
          @click="reschedule(item)">

          <v-icon center>mdi-update</v-icon>
        </v-btn>

        <StatusChip v-if="!item.incomplete && !item.future && item.status != 4" :status="item.status" />

        <v-btn icon v-if="item.status == 4" small color="blue lighten-1" text-color="#FFFFFF"
          :href="'/getCertificate/' + item.customer_id">

          <v-icon center>mdi-certificate-outline</v-icon>
        </v-btn>
      </template>

      <template v-slot:item.startTime="{ item }">
        <span>{{ new Date(item.startTime).toLocaleString("en-AU", {
          timeZone: "UTC", weekday: 'short', year: 'numeric',
          month: 'short', day: 'numeric'
        }) }}</span>
      </template>


      <template v-slot:item.billItems="{ item }">
        <p class="extras">{{ item.names }}</p>

      </template>
    </v-data-table>
  </v-main>
</template>

<script>
import { mapState } from 'vuex'
import StatusChip from '../components/StatusChip.vue'
import SearchRangePicker from '../components/SearchRangePicker.vue'
import Purchased from '../components/Purchased.vue'

export default {

  components: {
    StatusChip, SearchRangePicker, Purchased
  },

  data: () => ({


    valid: true,

    headers: [
      //  { text: '', value: 'data-table-expand' },
      { text: 'Date', align: 'start', sortable: true, value: 'startTime', dataType: "Date" },
      { text: 'Pckg', align: 'start', sortable: true, value: 'code', },
      { text: 'Customer', align: 'start', sortable: true, value: 'fullName', },
      { text: 'Status', value: 'actions', sortable: false },
      { text: 'Addons', align: 'start', sortable: true, value: 'billItems', },
      { text: 'Transport', align: 'start', sortable: true, value: 'transport', },
      { text: 'Payment', align: 'start', sortable: true, value: 'paymentMethod', },
      { text: 'Agent', align: 'start', sortable: true, value: 'creationAgent', },
      { text: 'Notes', align: 'start', sortable: true, value: 'notes', },
    ],
    name: '',

    date_filter: {
      type: 'range',
      start: '',
      end: ''
    },

    statusOpts: [
      { id: -1, text: "Cancelled after Take Off" },
      { id: 0, text: "Cancelled DZ/Weather" },
      { id: 1, text: "Booked", color: "" },
      { id: 2, text: "Checked-in", color: "green" },
      { id: 3, text: "In Progress" },
      { id: 4, text: "Landed" },
    ],
    transportOpts: [null, 'Bus', 'Airplane', 'Self Drive'],
    paymentMethodOpts: [null, 'CC', 'Cash', 'prepaid', 'refunded', 'paid'],



    filters: {
      selectedCodes: [],
      status: [],
      transport: [],
      paymentMethod: [],
      agent: []
    }
  }),

  mounted() {


    this.$store.dispatch('fetchAgents')

    this.changeRange(this.getDefaultWeek())
    //this.changeRange(["2021-03-25", "2021-03-31"])


  },

  computed: {

    ...mapState(['results']),
    ...mapState(['agents']),


    //  {

    // return this.$store.state.agents.map(a => {
    //         return a.name
    //     });
    // },

    expanded: {

      get() {

        return this.resuts
        //else return []
      },

      set(items) {
        return items
      }
    },


    agentsNames() {

      this.$store.state.agents.unshift(
        {
          id: null,
          name: null,
          email: null,
          prepaid: false,
          phone: null,
          commission: 0,
        })

      return this.agents.map(a => a.name)

    },


    codes() {


      return this.$store.state.products.map(p => p.code);
    },


    filteredResults() {


      let codes = this.filters.selectedCodes.length == 0 ? this.codes : this.filters.selectedCodes,

        statusOpts = this.filters.status.length == 0 ? this.statusOpts.map(o => o.id) : this.filters.status,

        transportOpts = this.filters.transport.length == 0 ? this.transportOpts : this.filters.transport,

        paymentMethodOpts = this.filters.paymentMethod.length == 0 ? this.paymentMethodOpts : this.filters.paymentMethod,

        agentOpts = this.filters.agent.length == 0 ? this.agentsNames : this.filters.agent


      return this.results.filter((r) => {
        return codes.includes(r.code)
      }).filter((r) => {
        return statusOpts.includes(r.status)
      }).filter((r) => {

        return transportOpts.includes(r.transport)

      }).filter((r) => {

        return agentOpts.includes(r.creationAgent)
      }).filter((r) => {

        return paymentMethodOpts.includes(r.paymentMethod)

      })


    },

    selectStatusOpts() {

      let selectableStatus = [-1, 0, 4]

      return this.statusOpts.map(o => o.id).filter((s) => {
        return selectableStatus.includes(i.d)
      })

    }


  },

  methods: {

    changeRange(range) {

      this.date_filter.start = range[0]
      this.date_filter.end = range[1]



      this.$store.dispatch('fetchResults', this.date_filter)

    },
    reschedule(item) {


      const index = this.results.indexOf(item)


      confirm('Are you sure you want to Reschedule to today?') &&
        axios.put('/api/jumps/reschedule/' + item.id)
          .then(response => {

            this.results.splice(index, 1)

          })
          .catch(err => {
            console.log(err)
          })

    },

  }

}
</script>